module.exports = __webpack_public_path__ + "960cdd2475e99e178804dcd21bbf3911.pdf";